import React, {createContext, useEffect, useState} from 'react';
import _StorageService from "@/services/storage.service";

const initialState  = {
    orgLogo: '',
    orgName: '',
    pageIcon: '',
    pageTitle: '',
    pageImage: '',
    pageContent: '',
    currentTheme: 'web',
    breadcrumb: {component: null},

    setOrgLogo: (value: any) => {},
    setOrgName: (value: string) => {},
    setPageIcon: (value: any) => {},
    setPageTitle: (value: string) => {},
    setPageImage: (value: any) => {},
    setPageContent: (value: any) => {},
    setBreadcrumb: (value: any) => {},
}

export const ThemeContext = createContext(initialState);

export const ThemeProvider = ({ children }) => {
    const StorageService = new _StorageService();

    const [orgLogo, changeOrgLogo] = useState<any>(initialState.orgLogo);
    const [orgName, changeOrgName] = useState<string>(initialState.orgName);
    const [pageIcon, changePageIcon] = useState<any>(initialState.pageIcon);
    const [pageTitle, changePageTitle] = useState<string>(initialState.pageTitle);
    const [pageImage, changePageImage] = useState<any>(initialState.pageImage);
    const [pageContent, changePageContent] = useState<any>(initialState.pageContent);
    const [breadcrumb, changeBreadcrumb] = useState<any>(initialState.breadcrumb);
    const [currentTheme, changeCurrentTheme] = useState<any>(initialState.currentTheme);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const themeFromUrl = params.get("theme");
        if (themeFromUrl) {
            setCurrentTheme(themeFromUrl);
        }
    }, [window.location.search]);

    useEffect(() => {
        const handleStorageChange = () => {
            const theme = StorageService.getCurrentTheme() || initialState.currentTheme;
            changeCurrentTheme(theme);
        };

        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("localStorageChanged", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("localStorageChanged", handleStorageChange);
        };
    }, []);

    const setOrgLogo = (value) => {
        changeOrgLogo(value);
    }

    const setOrgName = (value) => {
        changeOrgName(value);
    }

    const setPageIcon = (value) => {
        changePageIcon(value);
    }

    const setPageTitle = (value) => {
        changePageTitle(value);
    }

    const setPageImage = (value) => {
        changePageImage(value);
    }

    const setPageContent = (value) => {
        changePageContent(value);
    }

    const setBreadcrumb = (value) => {
        changeBreadcrumb(value);
    }

    const setCurrentTheme = (value) => {
        StorageService.setCurrentTheme(value);
        changeCurrentTheme(value);
    }

    const contextValue = {
        orgLogo,
        orgName,
        pageIcon,
        pageTitle,
        pageImage,
        pageContent,
        breadcrumb,
        currentTheme,

        setOrgLogo,
        setOrgName,
        setPageIcon,
        setPageTitle,
        setPageImage,
        setPageContent,
        setBreadcrumb,
        setCurrentTheme
    };

    return (
        <ThemeContext.Provider value={contextValue}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeProvider;
